<template>
    <div class="dashboard-container">
        <side-bar />
        <div class="main-content">

            <!--Breadcrumbs and title embedded within below data page-->
            <div class="container">
                <partner-breadcrumbs />
            </div>
            <div v-if="customerGUID === 'AD19537023AE4333B185521BF7078F60'" class="state-dropdown-container">
                <label for="state-select">State</label>
                <select id="state-select" v-model="selectedState">
                    <option v-for="state in australianStates" :key="state.value" :value="state.value">
                        {{ state.text }}
                    </option>
                </select>
            </div>
            <div class="tabs">
                <div class="tab-header">
                    <button class="tab-button"
                        @click="$router.push({ path: '/partner/customer', query: { activeTab: 'bots' } })"
                        :class="{ active: activeTab === 'bots' }">AI Agents</button>
                    <button class="tab-button"
                        @click="$router.push({ path: '/partner/customer', query: { activeTab: 'outboundCampaign' } })"
                        :class="{ active: activeTab === 'outboundCampaign' }">Outbound Calling</button>
                </div>
            </div>
            <div class="wizard-steps">
                <div class="current">
                    <div class="num">1</div>
                    <span class="step">Create Campaign</span>
                    <span class="arrow">&#8594;</span>
                </div>
                <div class="num">2</div> <span class="step">Add Targets</span>
            </div>

            <div class="form-wrapper">
                <form class="campaign-form" @submit.prevent="handleSubmit">
                    <h3>General settings</h3>
                    <div class="form-row inline-row">
                        <div class="form-group spaced">
                            <label>Bot Name*</label>
                            <select required v-model="data.botId">
                                <option v-if="bots.length === 0" value="" disabled>
                                    No bots available for the selected state
                                </option>
                                <option v-for="bot in bots" :key="bot.BotID" :value="bot.BotID">
                                    {{ bot.Bot_Name }}
                                </option>
                            </select>
                        </div>
                        <div class="form-group spaced">
                            <label>Campaign Name*</label>
                            <font-awesome-icon class="info-icon" icon="fa-circle-info" v-b-tooltip.hover
                                title="campaign name can't have spaces" />
                            <input type="text" required v-model="data.campaignName" />
                        </div>
                    </div>
                    <hr class="left-align" />

                    <h3>Schedule Settings</h3>
                    <div class="form-row inline-row">
                        <div class="form-group spaced">
                            <label>Time Zone*</label>
                            <select required v-model="timeZone">
                                <option value="Australia/Sydney">(UTC+10) Australia/Sydney</option>
                                <option value="Australia/Darwin">(UTC+9:30) Australia/Darwin</option>
                                <option value="Asia/Singapore">(UTC+8) Asia/Singapore</option>
                                <option value="Pacific/Auckland">(UTC+12) New Zealand</option>
                                <option value="Asia/Bangkok">(UTC+7) Asia/Bangkok</option>
                            </select>
                        </div>
                    </div>
                    <hr class="left-align" />

                    <h3>Campaign Time</h3>
                    <div class="form-row inline-row">
                        <div class="form-group spaced">
                            <label>Start Time</label>
                            <input type="time" v-model="data.startLocalTime" />
                        </div>
                        <div class="form-group spaced">
                            <label>End Time<font-awesome-icon class="info-icon" icon="fa-circle-info" v-b-tooltip.hover
                                    title="End Time must be greater than Start Time and the Current time, all in the same timezone" /></label>
                            <div class="input-with-note">
                                <input type="time" v-model="data.stopLocalTime" :min="minStopTime" />
                                <small class="input-note">End Time must be greater than Start Time and the Current time,
                                    all in the same timezone</small>
                            </div>
                        </div>
                    </div>


                    <div class="form-row">
                        <label>Campaign Days</label>
                    </div>
                    <div class="checkbox-row">
                        <label><input type="checkbox" v-model="daysOfWeek
                            .Sunday" /> Sunday</label>
                        <label><input type="checkbox" v-model="daysOfWeek
                            .Monday" /> Monday</label>
                        <label><input type="checkbox" v-model="daysOfWeek
                            .Tuesday" /> Tuesday</label>
                        <label><input type="checkbox" v-model="daysOfWeek
                            .Wednesday" /> Wednesday</label>
                        <label><input type="checkbox" v-model="daysOfWeek
                            .Thursday" /> Thursday</label>
                        <label><input type="checkbox" v-model="daysOfWeek
                            .Friday" /> Friday</label>
                        <label><input type="checkbox" v-model="daysOfWeek
                            .Saturday" /> Saturday</label>
                        <label>
                            <input type="checkbox" v-model="Everyday
                                " @change="toggleSelectAll" /> Everyday
                        </label>
                    </div>

                    <hr class="left-align" />

                    <h3>Campaign Date Range</h3>
                    <div class="form-row inline-row">
                        <div class="form-group spaced">
                            <label>Start Date*
                                <font-awesome-icon class="info-icon" icon="fa-circle-info" v-b-tooltip.hover
                                    title="Start date cannot be in the past" />
                            </label>
                            <input type="date" required v-model="data.beginningDate" :min="minStartDate" />
                        </div>
                        <div class="form-group spaced">
                            <label>End Date*
                                <font-awesome-icon class="info-icon" icon="fa-circle-info" v-b-tooltip.hover
                                    title="End date should be greater than start date" />
                            </label>
                            <input type="date" required v-model="data.endingDate" :min="data.beginningDate" />
                        </div>
                    </div>
                    <hr class="left-align" />

                    <h3>Call Rate Settings</h3>
                    <div class="form-row inline-row">
                        <div class="form-group spaced">
                            <label>Maximum Calls Per Second* <small>(Range: 1-30)</small></label>
                            <input type="number" placeholder="Range: 1-30" required v-model="data.maxCps" />
                        </div>
                        <div class="form-group spaced">
                            <label>Maximum Concurrent Calls* <small>(Range: 1-100)</small></label>
                            <input type="number" placeholder="Range: 1-100" required
                                v-model="data.maxConcurrentCalls" />
                        </div>
                        <hr class="left-align" />
                        <div class="side-by-side-section">
                            <label class="checkbox-label">
                                <input type="checkbox" v-model="showAdvancedSettings" />
                                <span>Advanced Settings</span>
                            </label>
                        </div>
                    </div>
                    <hr class="left-align" />

                    <div v-if="showAdvancedSettings">
                        <h3>Call Failure and Answering Machine Settings</h3>
                        <div class="form-row inline-row">
                            <div class="form-group spaced">
                                <label>Maximum Retries <small>(Range: 1-10)</small></label>
                                <input type="number" placeholder="Range: 1-10" v-model="data.maxRetries" />
                            </div>
                            <div class="form-group spaced">
                                <label>Minimum Duration Between Retries <small>(Range: 1-400 min)</small></label>
                                <input type="number" placeholder="Range: 1-400 min"
                                    v-model="data.minDurationBetweenRetries" />
                            </div>
                        </div>

                        <div class="form-row inline-row">
                            <div class="form-group spaced">
                                <label>Action Triggered By Machine Detection</label>
                                <input type="text" value="Disconnect" v-model="machineDetection" disabled />
                            </div>
                            <div class="form-group spaced">
                                <label>Minimum Wait Time For Answer <small>(Range: 1-300 sec)</small></label>
                                <input type="number" placeholder="Range: 1-300 sec"
                                    v-model="data.minWaitDurationForAnswer" />
                            </div>
                        </div>
                    </div>
                    <p class="customization-note">
                        For additional options and customizations, please email us at
                        <a href="mailto:support@trimate.ai">support@trimate.ai</a>.
                    </p>
                    <button type="submit" class="save-btn">SAVE & NEXT →</button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import SideBar from './SideBar.vue'
import PartnerBreadcrumbs from './PartnerBreadcrumbs.vue'

export default {
    name: 'MainConfig',
    components: {
        SideBar,
        PartnerBreadcrumbs

    },
    data() {
        return {
            activeTab: 'outboundCampaign',
            customerGUID: '',
            selectedState: 'All',
            australianStates: [
                { value: 'All', text: 'All States' },
                { value: 'NSW', text: 'New South Wales' },
                { value: 'QLD', text: 'Queensland' },
                { value: 'VIC', text: 'Victoria' },

            ],
            data: {
                botId: '',
                campaignName: '',
                startLocalTime: '00:00',
                stopLocalTime: '23:59',
                beginningDate: '',
                endingDate: '',
                maxCps: 1,
                maxConcurrentCalls: 10,
                maxRetries: 3,
                minDurationBetweenRetries: 5,
                minWaitDurationForAnswer: 20,
                answerMachineBeepTimeout: 20
            },
            daysOfWeek: {
                Sunday: false,
                Monday: false,
                Tuesday: false,
                Wednesday: false,
                Thursday: false,
                Friday: false,
                Saturday: false
            },
            Everyday: false,
            timeZone: 'Australia/Sydney',
            machineDetection: 'Disconnect',
            botName: '',
            bots: [],
            showAdvancedSettings: false,
            minStartDate: ''
        }
    },
    mounted() {
        this.customerGUID = (localStorage.getItem('customerGUID') || '').toUpperCase();

        // Initialize selectedState from query params or local storage
        const queryState = this.$route.query.state;
        const savedState = localStorage.getItem('selectedState');
        if (queryState) {
            this.selectedState = queryState;
        } else if (savedState) {
            this.selectedState = savedState;
        }

        this.fetchBots();
        const today = new Date();
        const oneMonthLater = new Date();
        oneMonthLater.setMonth(today.getMonth() + 1);
        this.minStartDate = this.formatDate(today);
        this.data.beginningDate = this.formatDate(today);
        this.data.endingDate = this.formatDate(oneMonthLater);
    },
    watch: {
        'data.campaignName'(newValue) {
            this.data.campaignName = newValue.replace(/\s/g, '');
        },
        selectedState(newState) {
            localStorage.setItem('selectedState', newState);
            this.fetchBots();
        },
        daysOfWeek: {
            handler(newDays) {
                this.Everyday = Object.values(newDays).every(Boolean);
            },
            deep: true
        }
    },
    computed: {
        minStopTime() {
            const now = new Date();
            const today = this.formatDate(now);

            if (this.data.beginningDate === today) {
                const hours = String(now.getHours()).padStart(2, '0');
                const minutes = String(now.getMinutes()).padStart(2, '0');
                const currentTime = `${hours}:${minutes}`;


                return this.data.startLocalTime > currentTime ? this.data.startLocalTime : currentTime;
            }
            return this.data.startLocalTime;
        }
    },
    methods: {
        async fetchBots() {
            if (!this.customerGUID) {
                console.error('Customer GUID not found in local storage.');
                this.$router.push('/partner/dashboard');
                return;
            }
            // bot name fetch for dropdown
            const selectedState = this.selectedState;
            try {
                const response = await fetch(`${process.env.VUE_APP_VORTEX_PORTAL_WS}/bots/all`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ 'customerGUID': this.customerGUID.trim() })
                });
                const result = await response.json();
                if (result.bots && Array.isArray(result.bots)) {
                    let bots = result.bots;
                    if (selectedState && selectedState !== 'All' && selectedState !== '') {
                        bots = bots.filter(bot => {
                            const botState = (bot.Bot_State || bot.botState || bot.BotState);
                            return botState === selectedState || (bot.Bot_Name && bot.Bot_Name.toUpperCase().startsWith(selectedState.toUpperCase()));
                        });
                    }
                    this.bots = bots;
                }
            } catch (error) {
                console.error('Error fetching or parsing bots data:', error);
            }
        },
        formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        toggleSelectAll() {
            const newVal = this.Everyday;
            for (const day in this.daysOfWeek) {
                this.daysOfWeek[day] = newVal;
            }
        },
        async handleSubmit() {
            const customerGUID = localStorage.getItem('customerGUID');
            if (!customerGUID) {
                console.error('Customer GUID not found in local storage.');
                alert('Session expired. Please login again.');
                this.$router.push('/partner/dashboard');
                return;
            }

            // Time validation
            const now = new Date();
            const today = this.formatDate(now);

            if (this.data.endingDate < today) {
                alert('Campaign creation failed: The end date has already passed.');
                return;
            }

            if (this.data.stopLocalTime <= this.data.startLocalTime) {
                alert('End Time must be greater than Start Time.');
                return;
            }

            const selectedBot = this.bots.find(bot => bot.BotID === this.data.botId);
            if (selectedBot) {
                this.botName = selectedBot.Bot_Name;
                localStorage.setItem('botDisplayName', this.botName);
                localStorage.setItem('campaignBotDID', selectedBot.Bot_DID);
            }

            const selectedDays = Object.keys(this.daysOfWeek).filter(day => this.daysOfWeek[day]);

            const payload = {
                data: {
                    bot_id: this.data.botId,
                    campaignName: this.data.campaignName,
                    schedulerSettings: {
                        timeZone: this.timeZone,
                        beginningDate: this.data.beginningDate,
                        endingDate: this.data.endingDate,
                        maxCps: this.data.maxCps,
                        maxConcurrentCalls: this.data.maxConcurrentCalls,
                        startLocalTime: this.data.startLocalTime,
                        stopLocalTime: this.data.stopLocalTime,
                        daysOfWeek: selectedDays,
                        minDurationBetweenRetries: this.data.minDurationBetweenRetries
                    },
                    detectionCapabilities: {
                        machineDetection: this.machineDetection,
                        minWaitDurationForAnswer: this.data.minWaitDurationForAnswer,
                        answerMachineBeepTimeout: this.data.answerMachineBeepTimeout
                    },
                    maxRetries: this.data.maxRetries,
                    adminState: "Unlocked",

                }
            };

            try {
                const baseUrl = process.env.VUE_APP_VORTEX_PORTAL_WS;
                const response = await fetch(`${baseUrl}/customers/${customerGUID}/campaign/create`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload)
                });

                const result = await response.json();

                if (response.ok && result.success) {
                    alert('Campaign created successfully!');
                    const campaignId = result.campaign.campaignID;
                    this.$router.push({
                        path: '/partner/outbound-targets', query: {
                            campaignid: campaignId,
                            botid: this.data.botId,
                            botname: this.botName
                        }
                    });
                } else {
                    throw new Error(result.message || 'Failed to create campaign.');
                }
            } catch (error) {
                console.error('Error creating campaign:', error);
                alert(`${error.message}`);
            }
        }
    }
}
</script>



<style scoped>
/* wizard css */
.wizard-steps {
    text-align: left;
    background-color: #fafafa;
    border-top: #e5e5e5 1px solid;
    border-bottom: #e5e5e5 1px solid;
    width: 95%;
    padding: 10px;
    color: #666;
    font-size: 16px;
    font-family: 'Montserrat';
    font-weight: bold;
    margin-bottom: 30px;
}

.num {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    background: #fff;
    margin-left: 10px;
    margin-right: 5px;
    border: 2px solid #e5e5e5;
    font-size: 15px;
    font-weight: 600;
    font-family: 'Montserrat', sans-serif;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.completed,
.current {
    display: inline-block;
}

.completed .step,
.completed .arrow {
    color: #42a593;
}

.current .step,
.current .arrow {
    color: #e45f2b;
}

.completed .num {
    background-color: #64CEBB;
    color: #fff;
    border: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.current .num {
    background-color: #FE602F;
    color: #fff;
    border: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.arrow {
    margin-left: 5px;
    font-size: 22px;
    font-weight: bolder;
}



.Heading {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 10px;
    margin-bottom: 30px;
}

.Heading h2 {
    margin: 0;
}

.add-btn {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    background-color: #E45F2B;
    color: white;
    font-weight: bold;
    border: none;
    border-radius: 20px;
    cursor: pointer;
    padding: 10px 25px;
    font-size: 14px;
    transition: background-color 0.2s ease-in-out;
}

.add-btn:hover {
    background-color: #000000;
}

.form-wrapper {
    padding: 0 1rem;
    width: 100%;
    max-width: 1080px;
}

.campaign-form {
    font-family: 'Montserrat', sans-serif;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    width: 100%;
}

.campaign-form h3 {
    font-weight: 500;
    margin: 0;
    font-size: 1.1rem;
    text-transform: uppercase;
}

.form-row {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 1.5rem 2.5rem;
    justify-content: flex-start;
    margin-left: 0;
    padding-left: 0;
}

.form-group {
    display: flex;
    align-items: baseline;
    gap: 1rem;
    flex: 1;
    min-width: 280px;
}

.form-group strong {
    width: 180px;
    text-align: left;
    display: inline-block;
}

.form-group.spaced {
    margin-right: 0;
}

.checkbox-row {
    display: flex;
    flex-wrap: wrap;
    gap: 1.5rem;
    margin-block-start: -1rem;
}

.left-align {
    width: 100%;
    margin: 0;
    border: none;
    border-top: 1px solid #ccc;
}

input,
select {
    padding: 0.5rem 0.75rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 0.875rem;
    font-family: inherit;
    transition: box-shadow 0.2s ease, border-color 0.2s ease;
    width: 100%;
    max-width: 300px;
}

input:focus,
select:focus {
    outline: none;
    border-color: black;
}

.save-btn {
    align-self: flex-start;
    cursor: pointer;
    border: none;
    border-radius: 20px;
    color: #FFFFFF;
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    font-weight: 400;
    height: 34px;
    padding: 0 1.25rem;
    text-align: center;
    text-transform: uppercase;
    background-color: #E45F2B;
}

.save-btn:hover {
    background-color: #000000;
}

.info-icon {
    margin-left: 5px;
    color: #FE602F;
    cursor: default;
}

.checkbox-label {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.9rem;
    white-space: nowrap;
}

.input-note {
    font-size: 0.75rem;
    color: #6c757d;
    margin-top: 5px;
}

.customization-note {
    clear: both;
    padding-top: 20px;
    font-size: 14px;
    color: #555;
    font-style: italic;
}

.customization-note a {
    color: #e45f2b;
    text-decoration: underline;
}

.input-with-note {
    display: flex;
    flex-direction: column;
    flex: 1;
    max-width: 300px;
}

.input-note {
    font-size: 0.75rem;
    color: #6c757d;
    margin-top: 5px;
}

.state-dropdown-container {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 20px;
    padding-left: 1rem;
}

.state-dropdown-container label {
    white-space: nowrap;
}

.state-dropdown-container select {
    max-width: 200px;
}
</style>
